export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona negozio"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senza titolo"])}
}